import { useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import PlayIcon from "images/icons/play.svg";
import PauseIcon from "images/icons/pause.svg";

import { Lightbox } from "components/Lightbox";

interface Props {
  confirmText?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const SoundTestModal: React.FC<Props> = ({ confirmText, onClose, onConfirm }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const handleToggleSound = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play().catch(console.error);
    }

    setIsPlaying(!isPlaying);
  };

  return (
    // Nadpis "Hraje to?" je vždy přítomný (nezávisí na `isPlaying`), zůstává proto
    // v těle a jen pojmenuje dialog. [TD-344]
    <Lightbox show={true} onHide={onClose} bodyClassName="pt-0" bodyTitleId="sound-test-title">
      <div className="mb-8px mx-4 text-center">
        <Image src="/images/ducduc-bara.svg" />
        {/* Velikost drží `.fs-16`, ať se sjednocením na `h2` (globálně 17 px) nezmění
            vzhled — původní `h4` měl 16 px ($h4-font-size). [TD-344] */}
        <h2 id="sound-test-title" className="fs-16 mt-3">
          Hraje to?
        </h2>
        <p>
          Čekají tě poslechy v angličtině, pouští se automaticky a stejně jako u ostré zkoušky je nejde zastavit. Ujisti
          se, že ti to hraje.
        </p>
      </div>

      <div className="d-grid gap-8px mt-3">
        <Button className="w-100 d-flex align-items-center justify-content-center gap-8px" onClick={handleToggleSound}>
          {isPlaying ? (
            <PauseIcon height={18} width={18} style={{ position: "relative", top: "-1px" }} />
          ) : (
            <PlayIcon height={18} width={18} style={{ position: "relative", top: "-2px" }} />
          )}
          {isPlaying ? "Pozastavit test zvuku" : "Spustit test zvuku"}
        </Button>
        <Button variant="outline-secondary" className="w-100" onClick={onConfirm}>
          {confirmText ?? "Pokračovat"}
        </Button>
      </div>
      <audio
        ref={audioRef}
        src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
        onEnded={handleToggleSound}
        preload="auto"
      />
    </Lightbox>
  );
};
